import { Outlet } from 'react-router-dom';

import { EnvironmentBadge } from './EnvironmentBadge';
import { Footer } from './Footer';
import { Header } from './Header';

export function Layout() {
  return (
    <div className="flex min-h-screen flex-col">
      <EnvironmentBadge />
      <Header />
      <main className="flex-1">
        <Outlet />
      </main>
      <Footer />
    </div>
  );
}
